import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'

export const useGetAllCorporateAccounts = () => {
  const { currentStateId } = useCurrentStateStore()
  const get = useTypedApiClient({
    path: '/admin/corporate-accounts',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/corporate-accounts'],
    queryFn: async () => {
      const { data } = await get('', {
        headers: currentStateId
          ? { 'Current-State-Id': currentStateId.toString() }
          : undefined,
      })
      return data
    },
  })
}
